import type { RouteObject } from "react-router-dom";
import { NotFound } from "../components/not-found.components";
import { CampaignViewBrandScreen } from "../screens/brand/campaigns/campaign-view.brand.screen";
// import { CampaignHomeBrandScreen } from "../screens/brand/campaigns/campaign-home.brand.screen";
import { CampaignLivePostsBrandScreen } from "../screens/brand/campaigns/campaign-live-posts.brand.screen";
import { CampaignPostSearchBrandScreen } from "../screens/brand/campaigns/campaign-post-search.brand.screen";
import { CampaignDraftSubmissionsBrandScreen } from "../screens/brand/campaigns/campaign-draft-submissions.brand.screen";
import { Modal } from "../components/movables/modal.components";
import { PostRejectModalBrandScreen } from "../screens/brand/menus/post/post-reject-modal.brand.screen";
import { CampaignHomeBrandScreen } from "../screens/brand/campaigns/campaign-home.brand.screen";
import { CampaignPostSubmissionsBrandScreen } from "../screens/brand/campaigns/campaign-post-submissions.brand.screen";

export const brandRouter: Array<RouteObject> = [
	{
		path: ":campaignId",
		element: <CampaignViewBrandScreen />,
		children: [
			{
				path: "search",
				element: <CampaignPostSearchBrandScreen />,
				children: [
					{
						path: ":postId/draft-reject",
						element: (
							<Modal navigatePath="/ephemeral/brand-dash/:campaignId/search">
								<PostRejectModalBrandScreen />
							</Modal>
						),
					},
				],
			},
			{
				path: "live-posts",
				element: <CampaignLivePostsBrandScreen />,
			},
			{
				path: "draft-submissions",
				element: <CampaignDraftSubmissionsBrandScreen />,
				children: [
					{
						path: ":postId/draft-reject",
						element: (
							<Modal navigatePath="/ephemeral/brand-dash/:campaignId/draft-submissions">
								<PostRejectModalBrandScreen />
							</Modal>
						),
					},
				],
      },
			{
				path: "post-submissions",
				element: <CampaignPostSubmissionsBrandScreen />,
				children: [
					{
						path: ":postId/post-reject",
						element: (
							<Modal navigatePath="/ephemeral/brand-dash/:campaignId/post-submissions">
								<PostRejectModalBrandScreen />
							</Modal>
						),
					},
				],
			},
      {
        path: "campaign-metrics",
        element: <CampaignHomeBrandScreen/>
			}
		],
	},

	{
		path: "*",
		element: <NotFound />,
	},
];
